import '../Resources.scss';
import 'data/array';
import * as angular from 'angular';
import * as contentTypes from './ContentTypes.json';
import { ConfirmationModal } from 'modules/ui';
export class ResourceController {
    static $inject = ['application', 'ngToast', 'LoadingService', '$translate', '$scope', '$timeout', '$filter', 'ResourceService', 'ModalService', 'TranslateService', 'BlipToastService', 'BuilderSegmentService', 'addalsointhe$injectarrayintheendofthefileparameters', 'file'];
    //Getters and Setters
    get application() {
        return this._application;
    }
    set application(value) {
        this._application = value;
    }
    constructor(application, ngToast, LoadingService, $translate, $scope, $timeout, $filter, ResourceService, ModalService, TranslateService, BlipToastService, BuilderSegmentService, 
    // for new parameters, add also in the $inject array in the end of the file
    parameters, file) {
        'ngInject';
        this.BlipToastService = BlipToastService;
        this.BuilderSegmentService = BuilderSegmentService;
        this.resourceName = '';
        this.emojiRegex = new RegExp(/(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g);
        this.$onInit = () => {
            this.clearResource();
            this.contentTypesSelect = this.loadContentTypesKeyValue();
        };
        this.onChangeKey = (event) => {
            this.resource.key = event.detail?.value;
        };
        this.onChangeType = (event) => {
            this.resource.type = event.detail?.value;
            const contentType = this.contentTypes.find((c) => c.type == this.resource.type);
            if (contentType) {
                if (contentType.type.endsWith('json')) {
                    this.resourceContent = JSON.stringify(contentType.sample, undefined, 4);
                }
                else {
                    this.resourceContent = contentType.sample;
                }
                this.resourceName = contentType.name;
            }
        };
        this.onChangeContent = (event) => {
            this.resourceContent = event.detail?.value;
        };
        this.application = application;
        this._loadingService = LoadingService;
        this._$translate = $translate;
        this._$scope = $scope;
        this._$timeout = $timeout;
        this._$filter = $filter;
        this._contentService = ResourceService;
        this._modalService = ModalService;
        this.STATE = undefined;
        //Resource types: https://github.com/takenet/messaginghub-docs/tree/master/docs/en/content-types
        this.contentTypes = contentTypes[TranslateService.getCurrentLanguage()];
        //Pagination
        this.itemsPerPage = 20;
        this.perPageAux = 0;
        this.searchBy = 'key';
        this.contents = [];
        this.showInfo = false;
        this.query();
    }
    set resourceContent(value) {
        this.error = false;
        this._resourceContent = value;
        if (this.resource && this.resource.type && this.resource.type.endsWith('json')) {
            try {
                JSON.parse(value);
            }
            catch (e) {
                this.error = true;
            }
        }
    }
    get resourceContent() {
        return this._resourceContent;
    }
    get newResourceData() {
        return this.resource
            ? {
                key: this.resource.key,
                type: this.resource.type,
                content: this.resourceContent || '',
            }
            : '';
    }
    loadContentTypesKeyValue() {
        return this.contentTypes.map((type) => ({
            label: type.name,
            value: type.type,
        }));
    }
    clearForm() {
        this.clearResource();
        this.resourceContent = undefined;
        this.STATE = undefined;
    }
    clearResource() {
        this.resource = {
            key: undefined,
            type: undefined,
            content: undefined,
        };
    }
    toggleInfo() {
        this.showInfo = !this.showInfo;
    }
    openNewTab(url) {
        window.open(url, '_blank').focus();
    }
    canSave(data) {
        return data && data.type && data.key && !this.error;
    }
    disableLoader() {
        return this.isLoading || this.noMoreItems;
    }
    isCreationReady() {
        return Boolean(!this.error &&
            this.resourceContent &&
            this.resource.key &&
            this.resource.type);
    }
    async loadMore() {
        if (!this.canLoadMore || this.isLoading) {
            return;
        }
        this.perPageAux += this.itemsPerPage;
        await this.query();
    }
    addNewResources(type) {
        this.BuilderSegmentService.trackAddNewResource({}, true, this.application);
        this.STATE = type;
    }
    async query(clearCurrentContent) {
        if (this.isLoading) {
            return;
        }
        this.canLoadMore = false;
        this.isLoading = true;
        try {
            this._loadingService.startLoading();
            if (this.filter != this.lastFilter || clearCurrentContent) {
                this.perPageAux = 0;
                this.contents = [];
                this.noMoreItems = false;
            }
            this.lastFilter = this.filter;
            let payload;
            payload = {
                skip: this.perPageAux,
                take: this.itemsPerPage,
            };
            if (this.filter) {
                if (this.searchBy == 'key') {
                    payload.keyFilter = this.filter;
                }
                else {
                    payload.documentFilter = this.filter;
                }
            }
            const keys = await this._contentService.getResources(payload);
            if (keys.items.length == 0) {
                this.noMoreItems = true;
                return;
            }
            this.bindSingleResources(keys.items);
        }
        catch (e) {
            throw e;
        }
        finally {
            this.isLoading = false;
            this._loadingService.stopLoading();
        }
    }
    async bindSingleResources(keys) {
        const formatedResources = keys.map((value, index) => {
            return {
                key: value,
                index: this.contents.length + index,
            };
        });
        this.contents.push(...formatedResources);
        const contentPromises = formatedResources.map(async (value) => {
            const resource = await this._contentService.getResource(value.key);
            this.contents[value.index].type = resource.type;
            this.contents[value.index].content = resource.resource;
        });
        await Promise.all(contentPromises);
        this.canLoadMore = true;
    }
    async saveResource(resource, index) {
        const isEditing = resource?.content;
        let content = resource ? resource.content : this._resourceContent;
        const resourceItem = resource
            ? angular.copy(resource)
            : angular.copy(this.resource);
        if (!this.canSave(resourceItem) || !content) {
            return;
        }
        if (resourceItem.key.match(this.emojiRegex)) {
            this.BlipToastService.show('danger', {
                msg: await this._$translate('resources.toasts.error.keyNameError'),
            });
            return;
        }
        if (resourceItem.type.endsWith('json')) {
            content = resource
                ? JSON.parse(resourceItem.content)
                : JSON.parse(this._resourceContent);
        }
        resourceItem.content = content;
        try {
            this._loadingService.startLoading();
            if (!resource) {
                // Check if the resource exists
                try {
                    const existingResource = await this._contentService.getResource(resourceItem.key);
                    if (existingResource.resource) {
                        const title = await this._$translate('resources.duplicatedKeyModal.title');
                        const body = await this._$translate('resources.duplicatedKeyModal.body');
                        const yes = await this._$translate('utils.misc.yes');
                        const no = await this._$translate('utils.misc.no');
                        // Asks if the user want to replace it
                        const modal = await this._modalService.showModal(ConfirmationModal({
                            title: {
                                text: title,
                            },
                            body: body,
                            buttons: {
                                confirm: {
                                    text: yes,
                                },
                                cancel: {
                                    text: no,
                                },
                            },
                        }));
                        const confirmation = await modal.close;
                        if (!confirmation) {
                            return;
                        }
                        // Search for a local resource with the same key and remove
                        for (let i = 0; i < this.contents.length; i++) {
                            if (this.contents[i].key == resourceItem.key) {
                                this.contents.splice(i, 1);
                                break;
                            }
                        }
                    }
                }
                catch (err) {
                    // Ignore the 'The requested resource was not found' error
                    if (err.code != 67) {
                        throw err;
                    }
                }
            }
            await this._contentService.setResource(resourceItem);
            if (resource) {
                this.contents[index] = resource;
            }
            else {
                this.contents.unshift(resourceItem);
                this.clearForm();
            }
            // Resource saved
            this.BlipToastService.show('success', {
                msg: await this._$translate('resources.toasts.success.saveSuccessText'),
            });
        }
        catch (err) {
            this.BlipToastService.show('danger', {
                msg: await this._$translate('resources.toasts.error.saveErrorText'),
            });
            throw err;
        }
        finally {
            this._loadingService.stopLoading();
            if (!isEditing) {
                this.BuilderSegmentService.trackAddResource({
                    ResourceType: this.resourceName,
                    ResourceKey: resourceItem.key,
                }, true, this.application);
            }
        }
    }
    async deleteResource(resource, index) {
        try {
            this._loadingService.startLoading();
            await this._contentService.deleteResource(resource.key);
            //Remove from array too
            this.contents.splice(index, 1);
            this.BlipToastService.show('success', {
                msg: await this._$translate('resources.toasts.success.deleteSuccessText'),
            });
        }
        catch (e) {
            this.BlipToastService.show('danger', {
                msg: await this._$translate('resources.toasts.error.deleteErrorText'),
            });
            throw e;
        }
        finally {
            this._loadingService.stopLoading();
        }
    }
}
ResourceController.$inject = ['application', 'ngToast', 'LoadingService', '$translate', '$scope', '$timeout', '$filter', 'ResourceService', 'ModalService', 'TranslateService', 'BlipToastService', 'BuilderSegmentService', 'parameters', 'file'];
// Explicit $inject array for reliable dependency injection
ResourceController.$inject = [
    'application',
    'ngToast',
    'LoadingService',
    '$translate',
    '$scope',
    '$timeout',
    '$filter',
    'ResourceService',
    'ModalService',
    'TranslateService',
    'BlipToastService',
    'BuilderSegmentService',
];
